import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { ApiVisa, BaseApiTemplateService, BasicApiResponseModel, Core2Config } from "../shared";
import { Observable } from "rxjs";
import { MFACodeValidateDto } from "../../data-transfer-objects/mfa-code-validate-dto.model";

@Injectable({ providedIn: "root" })
export class MFAQRCodeRegistrationService extends BaseApiTemplateService<any> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + "mfa";
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + "mfa";
    this.httpClient = http;
  }

  generateQRCodeAsPNG(encodedEmail: string, visa: ApiVisa): Observable<BasicApiResponseModel<any>>{
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path + '/google/generate-qr/backoffice-ep?encodedEmail=' + encodedEmail;
    }
    return this.httpClient.get<BasicApiResponseModel<any>>(this.apiUrl,this.getHttpHeader(visa));
  }

  generateQRCodeAsURL(encodedEmail: string, visa: ApiVisa): Observable<BasicApiResponseModel<any>>{
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path + '/google/generate-otp-auth-url/backoffice-ep?encodedEmail=' + encodedEmail;
    }
    return this.httpClient.get<BasicApiResponseModel<any>>(this.apiUrl,this.getHttpHeader(visa));
  }

  validateQRCodeWitOTP(dto: MFACodeValidateDto, visa: ApiVisa): Observable<BasicApiResponseModel<any>>{
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path + '/google/validate-qr-code-response/backoffice-ep';
    }
    return this.httpClient.post<BasicApiResponseModel<any>>(this.apiUrl,dto,this.getHttpHeader(visa));
  }

  requestResetMFA(visa: ApiVisa): Observable<BasicApiResponseModel<any>>{
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path + '/request-reset-mfa/backoffice-ep';
    }
    return this.httpClient.get<BasicApiResponseModel<any>>(this.apiUrl,this.getHttpHeader(visa));
  }

  requestResetMFAComplete(visa: ApiVisa): Observable<BasicApiResponseModel<any>>{
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path + '/request-reset-mfa-complete/backoffice-ep';
    }
    return this.httpClient.get<BasicApiResponseModel<any>>(this.apiUrl,this.getHttpHeader(visa));
  }
}